import createSelector from 'web-app/util/custom-create-selector';
import * as WeekdayBookingSelectors from 'web-app/react/plans/manage-plan/weekdays/weekday-bookings/selectors';
import * as SharedSelectors from 'web-app/react/plans/manage-plan/shared-selectors';
import * as WeekdayHelpers from 'web-app/react/plans/manage-plan/weekdays/helpers';

const selectPlanPart = state => state.plans.managePlan.editWeekdays.planPart;
export const selectDayInEditor = state => state.plans.managePlan.editWeekdays.day;

const planPartUsedPlanPackages = createSelector(
    selectPlanPart,
    SharedSelectors.planUsedPackages,
    (planPart, planUsedPackages) => {
        return planUsedPackages.filter(usedPackage => {
            return planPart.sessionBookings.some(sessionBooking => sessionBooking.sessionId === usedPackage.sessionId);
        });
    },
);

export const makeGetAvailableWeekdaySessions = () => {
    const getAvailableWeekdaySessions = WeekdayBookingSelectors.makeGetAvailableWeekdaySessions();
    return createSelector(
        getAvailableWeekdaySessions,
        planPartUsedPlanPackages,
        (weekdaySessions, planPartUsedPlanPackages) =>
            weekdaySessions.filter(session => {
                return (
                    session.sessionType !== 'package' ||
                    planPartUsedPlanPackages.some(planPackage => planPackage.sessionId === session.sessionId)
                );
            }),
    );
};

export const editDay = createSelector(selectPlanPart, selectDayInEditor, (planPart, day) =>
    WeekdayHelpers.planPartToWeekday(planPart, day),
);
